// src/pages/VehicleManage.js
import React, {useContext, useEffect, useState} from "react";
import ReactDOM from "react-dom";
import {useLocation, useNavigate} from "react-router-dom";
import TabContext from "@/contexts/TabContext";
import {dateFormatDateTime, dateFormatToISOString, useListPageFilter} from "@/utils";
import {Confirm, InputPopup, PageTabs, Pagination, Toast} from "@/components";
import DatePicker from "react-datepicker";
import ko from "date-fns/locale/ko";
import Select from "react-select";
import {branchTypeOptions, memberStatusOptions, rolesOptions} from "@/constants/selectOptions";
import {usePutMemberMileageMutation} from "@/redux/adminMileageApi";

import registerExcel from "@/assets/files/excel_register_sample.xlsx";
import {useConfirmJoinMutation, useGetMemberListQuery, useUpdateMemberAliasMutation,} from "@/redux/adminMemberApi";
import {formatPhoneNumber} from "../../utils";


const pageFilter = {
    parameters: {
        page: 0,
        size: 20,
        query: "",
        stared_at: undefined,
        ended_at: undefined,
        member_status: undefined,
    },
};

export const AdminMemberManage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state: tabs, dispatch } = useContext(TabContext);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const handleTabAdd = () => {
            const existingTab = tabs.find((tab) => tab.url.split("?")[0] === location.pathname);
            if (!existingTab) {
                dispatch({
                    type: "ADD_TAB",
                    payload: { url: location.pathname + location.search, title: "회원 목록" },
                });
            }
        };

        handleTabAdd();
    }, [dispatch, location.pathname, location.search, tabs]);

    const [confirmJoin] = useConfirmJoinMutation();
    // const [updateMember] = useUpdateMemberMutation();
    const [updateMemberAlias] = useUpdateMemberAliasMutation();
    const [putMemberMileage] = usePutMemberMileageMutation();

    const { formData, handleChange, setFormData, parameters, toastMsg } = useListPageFilter(pageFilter, {
        confirmStatus: {
            confirmPopupStatus: false,
            confirmTitle: "",
            confirmDescription: "",
            confirmButtons: [],
        },
        memberEditPopupStatus: false,
        selectedMember: null,
        triggerSearch: false,
    });
    const { confirmStatus, memberEditPopupStatus, triggerSearch } = formData;

    const { data, error, refetch } = useGetMemberListQuery(parameters, {
        refetchOnMountOrArgChange: true,
        skip: !triggerSearch,
    });

    useEffect(() => {
        console.log(formData);
    }, [formData]);

    // 컴포넌트 마운트 시 초기 데이터 조회
    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            triggerSearch: true,
        }));
    }, []);
    // 검색 버튼 클릭
    const handleSearch = () => {
        setFormData((prev) => ({
            ...prev,
            parameters: { ...prev.parameters, page: 0 },
            triggerSearch: true,
        }));
    };



    const handleJoinConfirm = async (memberId) => {
        let res = await confirmJoin(memberId);
        if (res.error) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: "실패하였습니다.",
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                confirmStatus: {
                    ...prev.confirmStatus,
                    confirmPopupStatus: false,
                },
            }));
            setFormData((prev) => ({
                ...prev,
                parameters: { ...prev.parameters, page: 0 },
                triggerSearch: true,
            }));
            refetch();
        }
    };

    const handleMemberStatus = (member) => {
        if (member.memberStatus === "PENDING") {
            // 가입승인 하시겠습니까? 이후 가입승인 api
            setFormData((prev) => ({
                ...prev,
                confirmStatus: {
                    confirmPopupStatus: true,
                    confirmTitle: "가입승인",
                    confirmDescription: "해당 회원의 가입을 승인하시겠습니까?",
                    confirmButtons: [
                        { label: "예", className: "btn-primary", onClick: () => handleJoinConfirm(member.id) },
                        {
                            label: "아니오",
                            className: "btn-cancel",
                            onClick: () =>
                                setFormData((prev2) => ({
                                    ...prev2,
                                    confirmStatus: { confirmPopupStatus: false },
                                })),
                        },
                    ],
                },
            }));
        }
    };

    const handleOpenPopup = (item) => {
        const inputs = [
            {
                name: "name",
                label: "이름",
                type: "text",
                placeholder: "이름을 입력하세요",
                value: item?.member?.name || "",
            },
            {
                name: "phone",
                label: "연락처",
                type: "text",
                placeholder: "연락처를 입력하세요",
                value: item?.member?.phone || "",
            },
            {
                name: "alias",
                label: "별칭",
                type: "text",
                placeholder: "별칭을 입력하세요",
                value: item?.member?.primaryRentCorp?.alias || "",
            },
        ];

        const selects = [
            {
                name: "roles",
                label: "권한",
                options: [
                    { value: "ADMIN", label: "관리자" },
                    { value: "MASTER", label: "마스터" },
                    { value: "RENT_CORP", label: "렌트회사" },
                ],
                placeholder: "권한을 선택하세요",
                value: item.member?.roles?.[0] || "",
            },
        ];

        const buttons = [
            {
                label: "취소",
                className: "btn-cancel",
                onClick: () => setFormData((prev) => ({ ...prev, memberEditPopupStatus: false })),
            },
            {
                label: "확인",
                className: "btn-primary",
                onClick: async (values) => {
                    console.log("입력값:", values.inputValues);
                    console.log("선택값:", values.selectValues);
                    // TODO: 회원 수정 API 호출
                    let body = {
                        name: values.inputValues.name,
                        phone: values.inputValues.phone,
                        alias: values.inputValues.alias,
                    };
                    setLoading(true);
                    let response = await updateMemberAlias({
                        memberId: item.member.id,
                        body: body,
                    }).unwrap();
                    console.log(response);
                    refetch();
                    setLoading(false);
                    setFormData((prev) => ({
                        ...prev,
                        memberEditPopupStatus: false,
                        toastMsg: "회원 정보가 수정되었습니다.",
                    }));
                },
            },
        ];

        setFormData((prev) => ({
            ...prev,
            memberEditPopupStatus: true,
            selectedMember: item.member,
            popupContent: (
                <InputPopup
                    title="회원 정보 수정"
                    description="회원 정보를 수정해주세요."
                    inputs={inputs}
                    //selects={selects}
                    buttons={buttons}
                    onClose={() => setFormData((prev) => ({ ...prev, memberEditPopupStatus: false }))}
                />
            ),
        }));
    };

    const handleOpenMileagePopup = (item) => {
        const inputs = [
            {
                name: "mileage",
                label: "마일리지",
                type: "number",
                placeholder: "마일리지를 입력하세요",
                value: "",
            },
        ];

        const selects = [
            {
                name: "chargeType",
                label: "유형",
                options: [
                    { value: "PLUS", label: "추가" },
                    { value: "MINUS", label: "차감" },
                ],
                placeholder: "유형을 선택하세요",
            },
        ];

        const buttons = [
            {
                label: "취소",
                className: "btn-cancel",
                onClick: () => setFormData((prev) => ({ ...prev, memberEditPopupStatus: false })),
            },
            {
                label: "확인",
                className: "btn-primary",
                closeOnClick: false,
                onClick: async (values) => {
                    try {
                        if (!values.selectValues.chargeType) {
                            setFormData((prev) => ({ ...prev, toastMsg: "유형을 선택해주세요." }));
                            return;
                        }
                        if (!values.inputValues.mileage) {
                            setFormData((prev) => ({ ...prev, toastMsg: "마일리지를 입력해주세요." }));
                            return;
                        }

                        console.log("입력값:", values.inputValues);
                        console.log("선택값:", values.selectValues);
                        // TODO: 마일리지 수정 API 호출
                        let body = {
                            chargeType: values.selectValues.chargeType.value,
                            mileage: values.inputValues.mileage,
                        };
                        setLoading(true);
                        let response = await putMemberMileage({
                            memberId: item.member.id,
                            body: body,
                        }).unwrap();
                        console.log(response);
                        refetch();

                        setFormData((prev) => ({
                            ...prev,
                            memberEditPopupStatus: false,
                            toastMsg: "마일리지가 수정되었습니다.",
                        }));
                    } catch (error) {
                        setFormData((prev) => ({
                            ...prev,
                            toastMsg: error?.message || "마일리지 수정에 실패했습니다.",
                        }));
                    } finally {
                        setLoading(false);
                    }
                },
            },
        ];

        setFormData((prev) => ({
            ...prev,
            memberEditPopupStatus: true,
            selectedMember: item.member,
            popupContent: (
                <InputPopup
                    title="마일리지 수정"
                    description={`${item.member?.name}님의 마일리지를 수정합니다.`}
                    inputs={inputs}
                    selects={selects}
                    buttons={buttons}
                    onClose={() => setFormData((prev) => ({ ...prev, memberEditPopupStatus: false }))}
                />
            ),
        }));
    };

    return (
        <>
            {toastMsg && <Toast visible={true} msg={toastMsg} setFormData={setFormData} />}
            <div className="management container">
                <PageTabs />

                <div className="table-container">
                    <div className="table-head">
                        <span className="head-tit">회원 목록</span>
                        <div className="breadcrumbs">
                            <ul>
                                <li className="home"></li>
                                <li>ERP 관리</li>
                                <li>회원 목록</li>
                            </ul>
                        </div>
                    </div>
                    <TableFilter formData={formData} handleChange={handleChange} setFormData={setFormData} handleSearch={handleSearch} />

                    <div className="table-content">
                        <div className="table-option">
                            <div className="table-caption">
                                <span className="data-count">
                                    {data && data.pagination ? `전체 ${data.pagination.totalElements}건` : ""}
                                </span>
                            </div>
                        </div>

                        <div className="table-wrapper">
                            <div className="table">
                                <table>
                                    <colgroup>
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                        <col width="5%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">로그인 ID</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">이름</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">연락처</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">지역</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">별칭</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">소속</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">회원유형</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">생성일시</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">수정일시</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">상태</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit"></span>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data && data.data && data.data.length > 0 ? (
                                            data.data.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.member?.loginId || ""}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.member?.name || ""}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{formatPhoneNumber(item.member?.phone || "")}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">
                                                                {item.member?.firstAddressCode?.name || ""} {item.member?.secondAddressCode?.name || ""}{" "}
                                                                {item.member?.branchType &&
                                                                    `(${
                                                                        branchTypeOptions?.find(
                                                                            (option) => option.value === item.member?.branchType
                                                                        )?.label
                                                                    })`}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">{item.member?.primaryRentCorp?.alias || ""}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">
                                                                {item.rentCorps?.map((rentCorp) => rentCorp.corpName).join(", ")}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">
                                                                {item.member?.roles
                                                                    ?.map((role) => rolesOptions.find((e) => e.value === role)?.label)
                                                                    .join(", ")}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">
                                                                {dateFormatDateTime(item.member?.createdAt, "YYYY-MM-DD HH:mm:ss")}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">
                                                                {dateFormatDateTime(item.member?.updatedAt, "YYYY-MM-DD HH:mm:ss")}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <button
                                                                type="button"
                                                                className={`btn-cell btn-outline tag-box ${
                                                                    memberStatusOptions.find(
                                                                        (option) => option.value === item?.member?.memberStatus
                                                                    )?.tagColor || ""
                                                                }`}
                                                                onClick={() => handleMemberStatus(item.member)}
                                                            >
                                                                {memberStatusOptions.find(
                                                                    (option) => option.value === item.member?.memberStatus
                                                                )?.label || "미정"}
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="cell" data-align="center">
                                                            <button
                                                                type="button"
                                                                className="btn-cell btn-third"
                                                                onClick={() => handleOpenMileagePopup(item)}
                                                            >
                                                                마일리지
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn-cell btn-outline"
                                                                onClick={() => handleOpenPopup(item)}
                                                            >
                                                                정보수정
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn-cell btn-outline"
                                                                onClick={() => navigate(`/erp/member/manage/edit/${item.member?.id}`)}
                                                            >
                                                                상세보기
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <></>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {data && data.pagination && data.data.length > 0 && (
                            <Pagination pagination={data.pagination} setFormData={setFormData} />
                        )}
                    </div>
                </div>
            </div>

            {formData.memberEditPopupStatus && formData.popupContent}
            {/* Confirm 팝업 */}
            {confirmStatus?.confirmPopupStatus && (
                <Confirm
                    layer={true}
                    onClose={() =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        }))
                    }
                    title={confirmStatus.confirmTitle}
                    description={confirmStatus.confirmDescription}
                    buttons={confirmStatus.confirmButtons}
                />
            )}
        </>
    );
};

const TableFilter = ({ formData, setFormData, handleSearch }) => {
    const { parameters } = formData;
    const [activeButton, setActiveButton] = useState(null);

    const handleParameterChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                [name]: value,
            },
            triggerSearch: false,
        }));
    };

    const handleDateChange = (dates, type) => {
        const [start, end] = dates;
        if (type === "create") {
            setFormData((prev) => ({
                ...prev,
                parameters: {
                    ...prev.parameters,
                    started_at: start ? dateFormatToISOString(start, "start") : "",
                    ended_at: end ? dateFormatToISOString(end, "end") : "",
                },
                triggerSearch: false,
            }));
        }
        setActiveButton(null);
    };

    const setDateRange = (days, buttonIndex) => {
        const now = new Date();
        const start = new Date(now);
        start.setDate(start.getDate() - days);
        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                page: 0,
                started_at: dateFormatToISOString(start, "start"),
                ended_at: dateFormatToISOString(now, "end"),
            },
            triggerSearch: false,
        }));
        setActiveButton(buttonIndex);
    };
    


    return (
        <div className="table-filter">
            <div className="filter-row">
                <div className="filter-item">
                    <div className="item-head">
                        <span className="head-tit">상태 :</span>
                    </div>
                    <div className="item-content">
                        <div className="item-select">
                            <Select
                                options={memberStatusOptions}
                                className="filter-select"
                                classNamePrefix="filter-select"
                                isSearchable={false}
                                placeholder="회원상태"
                                onChange={(option) => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        parameters: { ...prev.parameters, member_status: option.value },
                                    }));
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="filter-item">
                    <div className="item-head">
                        <span className="head-tit">등록일 :</span>
                    </div>
                    <div className="item-content">
                        <div className="item-input">
                            <DatePicker
                                locale={ko}
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={20}
                                dateFormat="yyyy.MM.dd"
                                onKeyDown={(e) => e.preventDefault()}
                                selectsRange={true}
                                startDate={parameters.started_at ? new Date(parameters.started_at) : null}
                                endDate={parameters.ended_at ? new Date(parameters.ended_at) : null}
                                onChange={(e) => handleDateChange(e, "create")}
                            />
                        </div>
                    </div>
                </div>
                <div className="filter-item">
                    <div className="item-content">
                        <div className="item-buttons">
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 0 ? "active" : ""}`}
                                onClick={() => setDateRange(0, 0)}
                            >
                                당일
                            </button>
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 15 ? "active" : ""}`}
                                onClick={() => setDateRange(15, 15)}
                            >
                                15일
                            </button>
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 30 ? "active" : ""}`}
                                onClick={() => setDateRange(30, 30)}
                            >
                                1개월
                            </button>
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 90 ? "active" : ""}`}
                                onClick={() => setDateRange(90, 90)}
                            >
                                3개월
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="filter-row">
                <div className="filter-item">
                    <div className="item-content">


                        <div className="item-input" style={{width: "300px"}}>
                            <input
                                type="text"
                                placeholder="입력하세요."
                                name="query"
                                value={parameters.query}
                                onChange={handleParameterChange}
                            />
                        </div>


                        <div className="item-buttons">
                            <button type="button" className="btn-search" onClick={handleSearch}>
                                검색
                            </button>
                            <button
                                type="button"
                                className="btn-search"
                                onClick={() => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        parameters: {...pageFilter.parameters},
                                    }));
                                }}
                            >
                                초기화
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// 차량 일괄 등록 팝업
const VehicleExcelRegisterPopup = ({layer = true, onClose, formData, setFormData}) => {
    const navigate = useNavigate();

    const [serviceItems, setServiceItems] = useState(["TIRE_CHANGE"]);

    useEffect(() => {
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    const handleConfirm = () => {
        navigate(`/vehicle/manage/register/excel`);
    };

    const downloadExcelTemplate = () => {
        const link = document.createElement("a");
        link.href = registerExcel;
        link.download = "excel_register_sample.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>

            <div className="popup excel-register-popup">
                <div className="popup-head">
                    <div className="head-tit">
                        <span className="tit-main">차량 일괄 등록</span>
                    </div>
                    <div className="btn-close" onClick={onClose}></div>
                </div>
                <div className="popup-content">
                    <div className="excel-register-guide">
                        <div className="guide-box">
                            <div className="box-head">
                                <span className="head-tit">여러대의 차량을 한번에 등록하세요.</span>
                                <span className="head-sub">엑셀 양식 다운로드부터 업로드까지 차례대로 진행해주세요.</span>
                            </div>
                            <div className="box-content">
                                <div className="process-item">
                                    <div className="item-txt">
                                        <span className="txt-main">
                                            1. 엑셀 파일을 다운받아 차량번호 및 소유주(자동차등록증상)만 입력하시면 편하게 입력 가능합니다.
                                        </span>
                                    </div>
                                    <div className="item-action">
                                        <button type="button" className="btn btn-xs btn-outline" onClick={downloadExcelTemplate}>
                                            엑셀 양식 다운로드
                                        </button>
                                    </div>
                                </div>
                                <div className="process-item">
                                    <div className="item-txt">
                                        <span className="txt-main">
                                            2. 다운로드 후 데이터를 입력한 엑셀 파일을 업로드 해주세요. 1회 업로드 최대 가능대수는 100대
                                            입니다.
                                        </span>
                                    </div>
                                </div>
                                <div className="process-item">
                                    <div className="item-txt">
                                        <span className="txt-main">
                                            3. 자동차등록증 또는 보험가입증명서 파일을 업로드 해주세요. 단, 파일명은 서류상의 자동차번호와
                                            동일하게 해주세요.
                                        </span>
                                        <span className="txt-em">예) 123하1235.jpg / 154호9876.png / 197허6598.pdf</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="guide-box">
                            <div className="box-head">
                                <span className="head-tit">FAQ</span>
                                <span className="head-sub">엑셀 파일 업로드와 차량 등록에 관한 궁금증을 모두 해결해드립니다.</span>
                            </div>
                            <div className="box-content">
                                <div className="accordian">
                                    <details>
                                        <summary>
                                            <em>Q.</em> 기존에 업로드한 차량이 있으면 어떻게 될까요?
                                        </summary>
                                        <p>{`자동차 데이터 제공업체에서 데이터 업데이트가 이뤄지지 않아, 과거의 정보가 노출 되는 현상 입니다. 
                                            국산의 경우 3~4시간 뒤 다시 조회 해보시고, 수입의 경우 1일 이후에 다시 시도 부탁드립니다. 
                                            급하신 등록 건은 고객센터로 문의 하여 주시기 바랍니다.`}</p>
                                    </details>
                                    <details>
                                        <summary>
                                            <em>Q.</em> 소유주가 일치 하지 않으면 등록이 불가한가요?
                                        </summary>
                                        <p>{`자동차 데이터 제공업체에서 데이터 업데이트가 이뤄지지 않아, 과거의 정보가 노출 되는 현상 입니다. 
                                            국산의 경우 3~4시간 뒤 다시 조회 해보시고, 수입의 경우 1일 이후에 다시 시도 부탁드립니다. 
                                            급하신 등록 건은 고객센터로 문의 하여 주시기 바랍니다.`}</p>
                                    </details>
                                    <details>
                                        <summary>
                                            <em>Q.</em> 서류가 잘못 등록 될 수도 있나요?
                                        </summary>
                                        <p>{`자동차 데이터 제공업체에서 데이터 업데이트가 이뤄지지 않아, 과거의 정보가 노출 되는 현상 입니다. 
                                            국산의 경우 3~4시간 뒤 다시 조회 해보시고, 수입의 경우 1일 이후에 다시 시도 부탁드립니다. 
                                            급하신 등록 건은 고객센터로 문의 하여 주시기 바랍니다.`}</p>
                                    </details>
                                    <details>
                                        <summary>
                                            <em>Q.</em> 차량번호 조회에 실패 했습니다.
                                        </summary>
                                        <p>{`자동차 데이터 제공업체에서 데이터 업데이트가 이뤄지지 않아, 과거의 정보가 노출 되는 현상 입니다. 
                                            국산의 경우 3~4시간 뒤 다시 조회 해보시고, 수입의 경우 1일 이후에 다시 시도 부탁드립니다. 
                                            급하신 등록 건은 고객센터로 문의 하여 주시기 바랍니다.`}</p>
                                    </details>
                                    <details>
                                        <summary>
                                            <em>Q.</em> 조회 된 차량의 데이터카 실제 차량정보와 다릅니다.
                                        </summary>
                                        <p>{`자동차 데이터 제공업체에서 데이터 업데이트가 이뤄지지 않아, 과거의 정보가 노출 되는 현상 입니다. 
                                            국산의 경우 3~4시간 뒤 다시 조회 해보시고, 수입의 경우 1일 이후에 다시 시도 부탁드립니다. 
                                            급하신 등록 건은 고객센터로 문의 하여 주시기 바랍니다.`}</p>
                                    </details>
                                    <details>
                                        <summary>
                                            <em>Q.</em> 엑셀 파일이 업로드 되지 않습니다.
                                        </summary>
                                        <p>{`자동차 데이터 제공업체에서 데이터 업데이트가 이뤄지지 않아, 과거의 정보가 노출 되는 현상 입니다. 
                                            국산의 경우 3~4시간 뒤 다시 조회 해보시고, 수입의 경우 1일 이후에 다시 시도 부탁드립니다. 
                                            급하신 등록 건은 고객센터로 문의 하여 주시기 바랍니다.`}</p>
                                    </details>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="popup-bottom">
                    <button className="btn btn-primary btn-close" onClick={handleConfirm}>
                        일괄 등록하기
                    </button>
                </div>
            </div>
        </>,
        document.body
    );
};
